import {useLocation} from 'react-router-dom';

export const useCurrentRoutePath = () => {
  const location = useLocation();
  const currentPath: string = location.pathname.split('/').pop() || '';

  return currentPath;
};
